module.exports = __webpack_public_path__ + "static/media/reitway-global-property.48184619.csv";